export default (str) => {
    if(str === undefined || str === null) {
        return '';
    }

    str = str + '';
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};